import { Schedule } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import i18n from "multilingual";

// Small helper to generate a human-friendly label for sync task/group codes
export function generateLabel(code, t) {
  if (!code || typeof code !== 'string') return t ? t('Patient_Screen.UNKNOWN_TASK') : i18n.t('Patient_Screen.UNKNOWN_TASK');

  // Doctor-friendly overrides for well-known sync task codes
  const lower = code.toLowerCase();
  if (lower.includes('initialize')){
    return t ? t('Patient_Screen.INITIALIZE_SYNC_TASK') : i18n.t('Patient_Screen.INITIALIZE_SYNC_TASK');
  }
  if (lower.includes('priority-sync') || lower.includes('priority_sync') || lower.includes('priority')) {
    return t ? t('Patient_Screen.FETCHING_TODAYS_SCHEDULE') : i18n.t('Patient_Screen.FETCHING_TODAYS_SCHEDULE');
  }
  if (lower.includes('full-sync') || lower.includes('full_sync') || lower.includes('full')) {
    return t ? t('Patient_Screen.FETCHING_ALL_DATA') : i18n.t('Patient_Screen.FETCHING_ALL_DATA');
  }
  if(lower.includes('cleanup')){
    return t ? t('Patient_Screen.CLEANUP_TASK') : i18n.t('Patient_Screen.CLEANUP_TASK');
  }

  // Fallback transformation for other codes
  return code
    .replace(/task_group@/, '')
    .replace(/resource-sync\./, '')
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase());
}

export default generateLabel;
